import { gql } from "@apollo/client";

export const RETIRE_PET = gql`
  mutation retirePet($retirePetInput: RetirePetInput!) {
    retirePet(retirePetInput: $retirePetInput){
        id,
        deleted,
        messages
    }
}`;

